import { utils } from '@hh/global.js'
import { LitElement, html, css } from '@hh/global.js'

const { isTouch } = utils

class HHImageZoom extends LitElement {
  static properties = {
    zoomed: {
      reflect: true,
    },
    origin: {
      type: Object,
      state: true,
    },
  }

  static styles = css`
    :host {
      display: block;
      position: relative;
      overflow: hidden;
    }

    :host button {
      background: none;
      width: 100%;
      height: 100%;
      padding: 0;
      border: none;
      border-radius: 0;
      margin: 0;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 2;
      cursor: var(--cursor-plus), auto;
    }

    :host button:focus-visible {
      border: 1px solid;
    }

    :host([zoomed='true']) button {
      cursor: var(--cursor-minus), auto;
    }

    :host ::slotted([slot='image-wrapper']) {
      transform: scale(1);
      transform-origin: var(--transform-origin, center center);
      z-index: 1;
    }

    :host([zoomed='true']) ::slotted([slot='image-wrapper']) {
      transform: scale(1.8);
    }
  `

  constructor() {
    super()

    this.move = this.move.bind(this)
    this.resetOrigin()
  }

  connectedCallback() {
    super.connectedCallback()

    this.addEventListener('mousemove', this.move)
    this.addEventListener('keydown', this.move)
    this.addEventListener('mouseout', () => {
      this.zoomed = false
    })
    this.addEventListener('blur', () => {
      this.zoomed = false
      this.resetOrigin()
    })
  }

  toggleZoom() {
    if (isTouch()) return
    this.zoomed = !this.zoomed
  }

  move(event) {
    if (isTouch()) return
    const arrows = [
      'ArrowRight',
      'ArrowLeft',
      'ArrowUp',
      'ArrowDown',
      'Enter',
    ].includes(event?.key)
    if (arrows) {
      event.preventDefault()
      if (event.key === 'Enter') {
        this.toggleZoom()
        this.resetOrigin()
        return this.style.setProperty(
          '--transform-origin',
          `${this.origin.x}% ${this.origin.y}%`
        )
      }
      const step = 10
      switch (event.key) {
        case 'ArrowLeft':
          this.origin.x = this.origin.x - step
          if (this.origin.x < 0) {
            this.origin.x = 0
          }
          break
        case 'ArrowRight':
          this.origin.x = this.origin.x + step
          if (this.origin.x > 100) {
            this.origin.x = 100
          }
          break
        case 'ArrowUp':
          this.origin.y = this.origin.y - step
          if (this.origin.y < 0) {
            this.origin.y = 0
          }
          break
        case 'ArrowDown':
          this.origin.y = this.origin.y + step
          if (this.origin.y > 100) {
            this.origin.y = 100
          }
          break
        default:
          return
      }
      return this.style.setProperty(
        '--transform-origin',
        `${this.origin.x}% ${this.origin.y}%`
      )
    }
    const origin = {
      x: `${((event.pageX - this.offsetLeft) / this.offsetWidth) * 100}%`,
      y: `${((event.pageY - this.offsetTop) / this.offsetHeight) * 100}%`,
    }
    this.style.setProperty('--transform-origin', `${origin.x} ${origin.y}`)
  }

  resetOrigin() {
    this.origin = {
      x: 50,
      y: 50,
    }
  }

  render() {
    return html`
      <button @click="${this.toggleZoom}" type="button"></button>
      <slot name="image-wrapper"></slot>
    `
  }
}

customElements.define('hh-image-zoom', HHImageZoom)
